module.exports = __webpack_public_path__ + "static/klimatbutiken_logo-dd2b8c6b72dace9fd77022d73578113e.svg";